angular.module('satv.playlist.pitch')

.factory('PitchEmailModal', ['config', 'Modal', function(config, Modal) {
    return {
        open: function(params, data) {
            return Modal.create(
                config.templateRoot + '/templates/playlists/modals/pitch-email',
                params,
                data
            );
        }
    };
}])

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/services/PitchEmailModal.js